import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import getStore from '../store';
import { isDismissedToday } from '../utils/localStorageHelper';

const hydrateWasDismissedMutator: (mailboxInfo: MailboxInfo) => void = mutatorAction(
    'hydrateReplyNudgeWasDismissed',
    (mailboxInfo: MailboxInfo): void => {
        if (isDismissedToday(mailboxInfo)) {
            getStore().wasDismissed = true;
        }
    }
);

export default hydrateWasDismissedMutator;
